import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Card } from 'components'
import { DOCUMENTS_PAGE_LABELS } from 'app-constants'
import { STATICS } from 'statics'
import { DocumentLine } from './components'
import './style.scss'

export function Documents() {
  const [tab, setTab] = useState(DOCUMENTS_PAGE_LABELS[0].name)

  function renderTabItems(tabName) {
    const documentItem =
      DOCUMENTS_PAGE_LABELS.find(pageLabel => pageLabel.name === tabName) ||
      DOCUMENTS_PAGE_LABELS[0]

    return documentItem.items.map(
      ({ urlFile, name, description, event, btnLabel, icon, drawerKey }, index) => (
        <DocumentLine
          key={index}
          urlFile={urlFile}
          name={name}
          description={description}
          event={event}
          btnLabel={btnLabel}
          icon={icon}
          drawerKey={drawerKey}
        />
      )
    )
  }

  function renderTabs() {
    return DOCUMENTS_PAGE_LABELS.map(item => {
      const { name } = item
      const isActive = tab === name

      return (
        <div className='tabs' key={name}>
          <button
            type='button'
            className={`tab ${isActive ? '-active' : ''}`}
            onClick={() => setTab(name)}
          >
            {name}
          </button>
        </div>
      )
    })
  }

  return (
    <div className='documents-page'>
      <Link className='return' to='/'>
        <div className='icon'>
          <STATICS.ARROW_BACK />
        </div>
        VOLTAR
      </Link>
      <h1 className='title'>Documentos</h1>
      <Card className='card'>
        {renderTabs()}
        {renderTabItems(tab)}
      </Card>
    </div>
  )
}
